import { getErrorCode } from '../../../common/api/errors'

/**
 * Form fields a refused employee creation marks; the refusal's sentence itself is shown by the common alert.
 */
export const newEmployeeFieldErrors = (error: unknown): Record<string, string> =>
  getErrorCode(error) === 'USER_ALREADY_EXISTS' ? { uuid: 'Пользователь с таким логином уже есть' } : {}
